import { useTranslation } from "react-i18next";
import { AutoComplete } from "components/AutoComplete";
import {
  TRegionData,
  useRegionsData,
} from "components/SpecificAutoComplete/RegionAutoComplete/hooks";
import { TCity, TJurisdiction, TProvince } from "types/dto";
import clsx from "clsx";

type TProps = {
  onChange?: (value: {
    province?: TProvince;
    city?: TCity;
    jurisdiction?: TJurisdiction;
  }) => void;
  defaultValue?: {
    provinceId?: string;
    cityId?: string;
    jurisdictionId?: string;
  };
  disabled?: boolean;
  className?: string;
  parentBackgroundColor?: string;
};
const RegionAutoComplete = (props: TProps) => {
  const { onChange, disabled, defaultValue, className, parentBackgroundColor } =
    props;
  const { t } = useTranslation();
  const {
    availableCities,
    availableJurisdictions,
    citiesLoading,
    provincesLoading,
    availableProvinces,
    jurisdictionsLoading,
    setSelectedRegion,
    selectedRegion,
  } = useRegionsData();

  // const autoCompleteClasses = "w-[204px]";
  const autoCompleteClasses = "col-span-1";
  return (
    <div className={clsx("grid grid-cols-3 w-full gap-x-2", className)}>
      <AutoComplete
        parentBackgroundColor={parentBackgroundColor}
        onSelectItem={() => {
          // setIsShowSuggestionDetailAccount(false);
        }}
        // defaultSelected={selectedRegion.province}
        defaultSelected={availableProvinces.find(
          (item) => item.id === defaultValue?.provinceId
        )}
        // defaultSelected={{
        //   code: value || "",
        //   name: value || "",
        // }}
        onSelect={(value: any) => {
          setSelectedRegion((prev) => ({
            ...prev,
            province: value,
            city: undefined,
            jurisdiction: undefined,
          }));
        }}
        optionLabel="name"
        // suggestions={
        //   accountCodeStateHook?.detailAccount || [{ code: "", name: "" }]
        // }
        suggestions={availableProvinces}
        // onInputChange={debounce((inputValue) => {
        //   // setAccountCodeStateHook({
        //   //   typedDetailAccount: inputValue,
        //   // });
        // }, 350)}
        placeholder={t("province")}
        // hasLabel={false}
        // disabled={!watch(`titleCode`) || !watch(`headingCode`)}
        className={autoCompleteClasses}
        // inputTooltip={
        //   accountCodeStateHook?.detailAccount?.find(
        //     (item) => item.code === value
        //   )?.name
        // }
        onClear={() => {
          // setAccountCodeStateHook({
          //   selectedDetailAccount: undefined,
          // });
          // onChange(null);
          setSelectedRegion({
            province: undefined,
            city: undefined,
            jurisdiction: undefined,
          });
        }}
        loading={provincesLoading}
        // error={Boolean(errors.detailAccountCode)}
        disabled={disabled}
      />
      <AutoComplete
        parentBackgroundColor={parentBackgroundColor}
        onSelectItem={() => {
          // setIsShowSuggestionDetailAccount(false);
        }}
        // defaultSelected={selectedRegion.city}
        defaultSelected={availableCities.find(
          (item) => item.id === defaultValue?.cityId
        )}
        // defaultSelected={{
        //   code: value || "",
        //   name: value || "",
        // }}
        onSelect={(value: any) => {
          const _data = {
            province: selectedRegion.province,
            city: value,
            jurisdiction: undefined,
          };
          setSelectedRegion(_data);
          onChange?.(_data);
        }}
        optionLabel="name"
        // suggestions={
        //   accountCodeStateHook?.detailAccount || [{ code: "", name: "" }]
        // }
        suggestions={availableCities}
        // onInputChange={debounce((inputValue) => {
        //   // setAccountCodeStateHook({
        //   //   typedDetailAccount: inputValue,
        //   // });
        // }, 350)}
        placeholder={t("city")}
        // disabled={!watch(`titleCode`) || !watch(`headingCode`)}
        className={autoCompleteClasses}
        // inputTooltip={
        //   accountCodeStateHook?.detailAccount?.find(
        //     (item) => item.code === value
        //   )?.name
        // }
        onClear={() => {
          // setAccountCodeStateHook({
          //   selectedDetailAccount: undefined,
          // });
          // onChange(null);
          setSelectedRegion((prev) => ({
            ...prev,
            city: undefined,
            jurisdiction: undefined,
          }));
        }}
        loading={citiesLoading}
        // error={Boolean(errors.detailAccountCode)}
        disabled={!selectedRegion.province || disabled}
      />
      <AutoComplete
        parentBackgroundColor={parentBackgroundColor}
        onSelectItem={() => {
          // setIsShowSuggestionDetailAccount(false);
        }}
        // defaultSelected={selectedRegion.jurisdiction}
        defaultSelected={availableJurisdictions.find(
          (item) => item.id === defaultValue?.jurisdictionId
        )}
        // defaultSelected={{
        //   code: value || "",
        //   name: value || "",
        // }}
        onSelect={(value: any) => {
          const _data = {
            province: selectedRegion.province,
            city: selectedRegion.city,
            jurisdiction: value,
          };
          setSelectedRegion(_data);
          onChange?.(_data);
        }}
        optionLabel="name"
        // suggestions={
        //   accountCodeStateHook?.detailAccount || [{ code: "", name: "" }]
        // }
        suggestions={availableJurisdictions}
        // onInputChange={debounce((inputValue) => {
        //   // setAccountCodeStateHook({
        //   //   typedDetailAccount: inputValue,
        //   // });
        // }, 350)}
        placeholder={t("jurisdiction")}
        // disabled={!watch(`titleCode`) || !watch(`headingCode`)}
        className={autoCompleteClasses}
        // inputTooltip={
        //   accountCodeStateHook?.detailAccount?.find(
        //     (item) => item.code === value
        //   )?.name
        // }
        onClear={() => {
          // setAccountCodeStateHook({
          //   selectedDetailAccount: undefined,
          // });
          // onChange(null);
          const _data: TRegionData = {
            province: selectedRegion.province,
            city: selectedRegion.city,
            jurisdiction: undefined,
          };
          setSelectedRegion((prev) => ({
            ...prev,
            jurisdiction: undefined,
          }));
          onChange?.(_data);
        }}
        loading={jurisdictionsLoading}
        // error={Boolean(errors.detailAccountCode)}
        disabled={!selectedRegion.city || disabled}
      />
    </div>
  );
};

export default RegionAutoComplete;
